import React from "react";

import { TemplateInterface } from "../../../../store/roblox/templatesSlice";
import Meta, { MetaInterface } from "../../../../componets/Meta";

interface _MetaInterface {
  template: TemplateInterface | undefined;
  size?: MetaInterface['size'];
  shape?: MetaInterface['shape'];
  showStats?: boolean;
}

const TYPES = { 0: 'Pants', 1: 'Shirt', 2: 'TShirt' };

const _Meta = ({ template, shape, size }: _MetaInterface) => {
  if (!template) {
    return null;
  }

  return (
    <Meta
      url={template.url}
      size={size}
      shape={shape}
      avatar={template.thumbnail_url}
      title={TYPES[template.type_id]}
    />
  );
}

export default _Meta;
